import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { StockInRepository } from './repositories/stock-in-repositories';
import { StockInEntity } from './stock-in.entity';
import { WarehouseService } from './warehouse.service';
// import { ScheduleModule } from '@nestjs/schedule';
import { WarehouseController } from './warehouse.controller';


@Module({
  imports: [
    TypeOrmModule.forFeature([StockInEntity,StockInRepository])
  ],
  controllers: [WarehouseController],
  providers: [WarehouseService, ApplicationExceptionHandler]
})
export class WarehouseModule {}
